/**
 * Specifies whether a pathname belongs to core marketplace site
 * @param {String} pathname - current location pathname
 * @returns {Boolean}
 */
export const isExternalPathname = (pathname = '') => {
  const externalPathnames = ['/partners', '/native'];
  return externalPathnames.some(extPth => pathname.includes(extPth));
};
